import api from "../Api";
import routes from "../constants/ApiRoutesConstants";

export default async function GetSupportTickets(params) {
  const res = await api.get(routes.GET_SUPPORT_TICKETS, {
    params: params,
  });

  return res;
}
